import React, { useState, useEffect, useRef } from 'react';

const BASE = 'https://menu.searchisend.in';

const NetworkMap = () => {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    const mapRef = useRef(null);
    const mapContainerRef = useRef(null);

    useEffect(() => {
        const fetchMapData = async () => {
            try {
                const res = await fetch(`${BASE}/apimenu/v2/get_network_map.php`);
                const data = await res.json();
                if (data.success) {
                    setLocations(data.locations || []);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchMapData();
    }, []);

    useEffect(() => {
        if (loading) return;

        // Load Leaflet CSS and JS dynamically to avoid npm install issues
        const loadLeaflet = async () => {
            if (!window.L) {
                const css = document.createElement('link');
                css.rel = 'stylesheet';
                css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
                document.head.appendChild(css);

                const script = document.createElement('script');
                script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
                document.head.appendChild(script);

                await new Promise(resolve => {
                    script.onload = resolve;
                });
            }
            
            initMap();
        };

        const initMap = () => {
            if (!mapContainerRef.current || mapRef.current) return;
            
            // Initialize map centered around India
            const L = window.L;
            const map = L.map(mapContainerRef.current).setView([22.5937, 78.9629], 4);
            mapRef.current = map;

            // Use Carto light base map for a clean UI
            L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; OpenStreetMap contributors &copy; CARTO'
            }).addTo(map);

            // Add markers for locations
            locations.forEach(loc => {
                const marker = L.circleMarker([loc.lat, loc.lng], {
                    radius: Math.max(6, Math.min(25, loc.count * 3)),
                    fillColor: '#f97316', // Brand accent color
                    color: '#fff',
                    weight: 2,
                    opacity: 1,
                    fillOpacity: 0.8
                }).addTo(map);
                
                marker.bindPopup(`<b>${loc.city}, ${loc.state}</b><br/>${loc.count} Active Restaurant(s)`);
            });
        };

        loadLeaflet();

        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [locations, loading]);

    return (
        <div style={{ background: 'var(--bg-card)', padding: '20px', borderRadius: '12px', border: '1px solid var(--border-color)', height: '100%', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ margin: '0 0 15px 0', color: 'var(--text-primary)', fontSize: '1.2rem', display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-map-marker-alt" style={{ color: 'var(--accent-primary)', marginRight: '10px' }}></i>
                India Network Map
            </h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '20px' }}>
                Interactive live distribution of active restaurants across India.
            </p>
            
            <div style={{ flex: 1, position: 'relative', minHeight: '350px', borderRadius: '8px', overflow: 'hidden', border: '1px solid var(--border-color)' }}>
                {loading ? (
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'var(--text-secondary)', zIndex: 10 }}>
                        <i className="fas fa-spinner fa-spin fa-2x"></i>
                    </div>
                ) : locations.length === 0 ? (
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'var(--text-secondary)' }}>
                        No location data available.
                    </div>
                ) : (
                    <div ref={mapContainerRef} style={{ width: '100%', height: '100%', zIndex: 1 }} />
                )}
            </div>
        </div>
    );
};

export default NetworkMap;
